<template>
  <div>
    <filter-container
        :filterData="filterData"
        :filterDataSelected="filterDataSelected"
        :isPreloader="isPreloader"
        @onChangeFilter="onChangeFilter"
    />
    <div class="view-analytics__table-container">
      <div class="view-analytics__table-title">
        <slot name="baseTitle">
            {{currentTitle}}
        </slot>
      </div>

      <table-multiline
          :tableData="tableClients"
          :subrows="tableClientsSubrows"
          :activeRows="tableClientsActiveRows"
          :colspan="5"
          :isPreloader="isPreloader"
          :preloaderKeyRow="preloaderKeyRow"
          :isSort="true"
          :columnsSort="columnsSort"
          :columnsStyles="columnsStyles"
          @onClickTableItem="onClickTableMultilineItem"
          :isObjectCell="true"
          :rowTitleLimitIndex = "rowTitleLimitIndex"
      />
    </div>
  </div>
</template>

<script>
import FilterContainer from '../../components/Filter/FilterContainer';
import TableMultiline from '../../components/Tables/TableMultiline';
import mixinAnalytics from '../../mixins/mixinAnalytics';
import serviceApi from '../../services/serviceApi';
import schemeApi from '../../schemes/schemeApi';
let {
  routeAnalyticsClients,
} = schemeApi;
export default {
  name: 'ViewAnalyticsBase',
  components: {
    FilterContainer,
    TableMultiline
  },
  mixins: [
    mixinAnalytics
  ],
  props: {
    currentRoute: {
      type: String,
      default: routeAnalyticsClients
    },
    currentTitle: {
      type: String,
      default: ''
    },
    rowLabel: {
      type: String,
      default: ''
    },
    subColumnLabel: {
      type: String,
      default: 'Бренд'
    },
    rowTitleLimitIndex:{
      type: Number,
      default: 1
    }
  },
  /**
   * Данные компонента
   * @property {boolean} isPreloader - условие показа прелоадера
   * @property {string} preloaderKeyRow - ключ строки на который вешается прелоадер
   * @property {object} tableClients - таблица клиентов
   * @property {object} tableClientsSubrows - дочерниче строки для таблицы клиентов
   * @property {array} tableClientsActiveRows - активные родительские строки в таблице
   */
  data: () => ({
    isPreloader: false,
    preloaderKeyRow: '',
    tableClients: {},
    tableClientsSubrows: {},
    tableClientsActiveRows: [],
  }),
  watch: {
    rowLabel(){
      let tableData = this.tableClients;
      tableData.subColumns.rowLabel = this.rowLabel;
      this.tableClients = Object.assign({}, tableData);
    }
  },
  computed: {
    /**
     * тело запроса
     * @returns {object}
     */
    reqBodyGetDataClients() {
      let reqBody = {
        filter_params: this.filterDataSelected
      }
      return reqBody;
    },
    /**
     * колонки по которым можно сортировать
     */
    columnsSort() {
      let columnsSort = {};
      let {subColumns = {}} = this.tableClients;
      Object.keys(subColumns).forEach((column) => {
        if (column === 'rowLabel' || column === 'subColumnLabel')
          columnsSort[column] = {typeColumn: 'String'};
        else
          columnsSort[column] = {typeColumn: 'Number'};
      });
      return columnsSort;
    },
    columnsStyles() {
      let columnsStyles = {};
      const {subColumns = {}} = this.tableClients;
      Object.keys(subColumns).forEach((subColumn) => {
        const subColumnSplitted = subColumn.split('_');
        const subColumnKey = subColumnSplitted[2] || subColumnSplitted[0];
        switch(subColumnKey) {
          case 'rowLabel':
          case 'subColumnLabel':
            columnsStyles[subColumn] = {};
            break;
          default:
            columnsStyles[subColumn] = {'text-align': 'right',};
            break;
        }
      });
      return columnsStyles;
    }
  },
  mounted() {
    this.getDataClients();
  },
  methods: {
    /**
     * сделать запрос на получения данных
     * @async
     */
    async getDataClients() {
      this.isPreloader = true;
      try {
        let {data = {}} = await serviceApi.post(this.currentRoute, this.reqBodyGetDataClients);
        let {filter = {}, analytics = {}} = data;
        let {options = {}, months = {}, table_data: tableData = {}, row_labels: rowLabels = {}, sub_column_labels: subColumnLabels = {}} = analytics;

        this.setFilterData(filter);
        this.tableClients = this.collectDataTableMultiline(options, months, tableData, rowLabels, subColumnLabels);
        this.tableClientsSubrows = {};
        this.tableClientsActiveRows = [];
      }
      catch(error) {
        if (error.message === 'not server')
          alert('Извините, сервер временно недоступен');
      }
      this.isPreloader = false;
    },
    /**
     * сделать запрос на получение дочерних строк для таблицы
     * @async
     * @param {string} rowKey - ключ строки
     */
    async getDataClientsSubrows(rowKey) {
      this.preloaderKeyRow = rowKey;
      let reqBody = {
        ...this.reqBodyGetDataClients,
        row_id: rowKey
      };
      try {
        let {data = {}} = await serviceApi.post(this.currentRoute, reqBody);
        let {analytics = {}} = data;
        let {options = {}, months = {}, table_data: tableData = {}, row_labels: rowLabels = {}} = analytics;
        let {rows = {}} = this.collectDataTableMultiline(options, months, tableData, rowLabels);
        this.tableClientsSubrows = {
          ...this.tableClientsSubrows,
          [rowKey]: rows
        };
      }
      catch(error) {
        if (error.message === 'not server')
          alert('Извините, сервер временно недоступен');
      }
      this.preloaderKeyRow = '';
    },
    /**
     * собираем данные в нужном формате для таблицы
     * @param {object} options - опции для строк таблицы
     * @param {object} months - месяца
     * @param {object} tableData - данные таблицы
     * @param {object} rowLabels - заголовки строк
     * @returns {object}
     */
    collectDataTableMultiline(options, months, tableData, rowLabels, subColumnLabels = {}) {
      let monthsKeys = Object.keys(months);
      let monthsKeysNumber = monthsKeys.map(monthsKey => monthsKey);
      let columns = {};
      // monthsKeysNumber.sort();
      // monthsKeysNumber.reverse();
      monthsKeysNumber.forEach((monthsKey) => {
        columns[`${monthsKey}`] = months[monthsKey];
      });
      let subColumns = {};
      if (monthsKeys.length !== 0 && this.subColumnLabel){
        subColumns = {rowLabel: this.rowLabel, subColumnLabel: this.subColumnLabel};
      } else if(monthsKeys.length !== 0 && !this.subColumnLabel){
        subColumns = {rowLabel: this.rowLabel};
      }

      monthsKeys.forEach((columnKey) => {
        subColumns = {
          ...subColumns,
          [`_${columnKey}_earn`]: 'Выручка',
          [`_${columnKey}_consumption`]: 'Себестоимость',
          [`_${columnKey}_profit`]: 'Прибыль',
          [`_${columnKey}_tax`]: 'Налог',
          [`_${columnKey}_profit_without_tax`]: 'Прибыль с вычетом налога'
        };
      });

      let newRows = {};
      for (let [rowKey, rowValue] of Object.entries(tableData)) {
        for (let [rowColKey, rowColValue] of Object.entries(rowValue)) {
          let newRowColValue = {};
          Object.keys(rowColValue).forEach((rowColValueKey) => {
            newRowColValue[`_${rowColKey}_${rowColValueKey}`] = rowColValue[rowColValueKey];
          });
          if(this.subColumnLabel){
            newRows[rowKey] = {
              rowLabel: rowLabels[rowKey],
              subColumnLabel: typeof subColumnLabels[rowKey] !== 'undefined' ? subColumnLabels[rowKey][0] : '',
              ...newRows[rowKey],
              ...newRowColValue
            };
          }else {
            newRows[rowKey] = {
              rowLabel: rowLabels[rowKey],
              ...newRows[rowKey],
              ...newRowColValue
            };
          }
        }
      }

      let tableDataCollected = {
        options: options,
        columns: columns,
        subColumns: subColumns,
        rows: new Map(Object.entries(newRows))
      }
      return tableDataCollected;
    },
    /**
     * событие изменения фильтра
     * @param {object} newFilterData - новые данные фильтра
     */
    onChangeFilter(newFilterData) {
      this.setFilterSelected(newFilterData);
      this.filterDataSelected = newFilterData;
      this.getDataClients();
    },
    /**
     * Событие клика по иконке раскрыть/скрыть
     * @param {string} rowKey - ключ строки
     */
    onClickTableMultilineItem(rowKey) {
      if (Object.keys(this.tableClientsSubrows).includes(rowKey)) {
        if (this.tableClientsActiveRows.includes(rowKey)) {
          let index = this.tableClientsActiveRows.findIndex((row) => {
            return row === rowKey;
          });
          this.tableClientsActiveRows.splice(index, 1);
        }
        else {
          this.tableClientsActiveRows.push(rowKey);
        }
      }
      else {
        this.getDataClientsSubrows(rowKey);
        this.tableClientsActiveRows.push(rowKey);
      }
    },
  }
}
</script>

<style lang="scss" scoped>
</style>